/**
 * Uyaran şekillerinin ekrandaki çizimi.
 *
 * Geometri burada DEĞİL: `@nirengi/engine`'in `render/shapes.ts`'inde.
 * Yazdırma kanalı da aynı tablodan okuyor, böylece tablette görünen
 * şekille A4'e basılan şekil birebir aynı. İki kopya tutmanın bedelini
 * `EGZERSIZ_ADI` ile bir kez ödedik.
 *
 * SVG, dize olarak gömülmüyor (motorun `sekilSvg`'si kâğıt içindir);
 * burada React düğümü olarak kuruluyor. Sebep `dangerouslySetInnerHTML`
 * kaçınmak değil — motorun ürettiği dize zaten kapalı bir kümeden
 * geliyor — React'in yeniden çizimde düğümü tanıyabilmesi: dize gömmek
 * her hücre değişiminde DOM'u baştan kurduruyordu.
 */

import { SEKILLER, SEKIL_ADI, sekilMi } from '@nirengi/engine'
import type { ShapeName } from '@nirengi/engine'

/** Karıştırıcı kümede şeklin üstüne çizilen tam çember */
const CEMBER = SEKILLER.daire.d

export function Sekil({ ad }: { ad: ShapeName }) {
  const s = SEKILLER[ad]
  return (
    <svg
      className="sek"
      viewBox="0 0 100 100"
      role="img"
      aria-label={SEKIL_ADI[ad]}
      focusable="false"
    >
      <path
        d={s.d}
        /**
         * Renk `currentColor`: saran öğe belirliyor.
         *
         * Koyu tema, seçili şık ve doğru/yanlış işareti aynı şekli
         * farklı renkte çiziyor; şeklin kendisi hiçbirini bilmiyor.
         */
        fill={s.dolu ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth={s.dolu ? 2 : 9}
        transform={s.donme ? `rotate(${s.donme} 50 50)` : undefined}
      />
      {s.cember && <path d={CEMBER} fill="none" stroke="currentColor" strokeWidth={7} />}
    </svg>
  )
}

/**
 * Bir uyaran: şekilse çizilir, metinse yazılır.
 *
 * Çizim modelindeki her uyaran alanı bu ikisinden biri; hangisi olduğu
 * türde duruyor, çalışma anında aranmıyor.
 */
export function Uyaran({ shape, glyph }: { shape?: ShapeName; glyph?: string }) {
  if (shape) return <Sekil ad={shape} />
  return <>{glyph ?? ''}</>
}

/** Cevapta taşınan kimlik: şekil adı ya da metnin kendisi */
export function kimlik(i: { shape?: ShapeName; glyph?: string }): string {
  return i.shape ?? i.glyph ?? ''
}

/**
 * Yalnızca KİMLİK dizesi elimizdeyken çizim.
 *
 * Damgalama tahtası, palet seçimi ve cevap kutusu kimlik dizesi
 * taşıyor (çizim modelindeki tür bilgisi oraya kadar gelmiyor, çünkü
 * oradaki şey artık çocuğun verdiği cevap). Dize bir şekil adıysa
 * şekil çiziliyor, değilse metin yazılıyor.
 */
export function UyaranAdi({ ad }: { ad: string }) {
  return sekilMi(ad) ? <Sekil ad={ad} /> : <>{ad}</>
}

/**
 * Boşlukla ayrılmış kimlik dizisi — dizi hatırlamanın cevabı böyle
 * tutuluyor ("daire kare ucgen"). Her parça ayrı çiziliyor.
 */
export function Dizi({ metin, bos = '—' }: { metin: string; bos?: string }) {
  const parcalar = metin.split(' ').filter(Boolean)
  if (parcalar.length === 0) return <>{bos}</>
  return (
    <span className="dizi">
      {parcalar.map((p, i) => (
        <UyaranAdi key={i} ad={p} />
      ))}
    </span>
  )
}
